import React, { Fragment } from 'react';
import styled from 'styled-components';
import noop from 'lodash/noop';
import Icon from '@fortawesome/react-fontawesome';

import theme, { MEDIA_TINY } from 'styles/theme';

const Menu = styled.div`
  position: absolute;
  width: 150px;
  background: ${theme.B300};
  border: 1px solid ${theme.B500};
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
  bottom: 0;
  right: 0;
  margin-top: 25px;
  transform: translateY(100%);

  .Menu__title {
    display: block;
    text-transform: uppercase;
    background: ${theme.B400};
    border-bottom: 1px solid ${theme.B500};
    padding: 10px;
    font-size: 10px;
    text-align: center;
  }

  .Menu__item {
    display: block;
    text-align: center;
    padding: 10px;
    text-transform: uppercase;
  }

  @media (max-width: ${MEDIA_TINY}) {
    left: 0;
    width: auto;
  }
`;

const UserNav = ({ user = {}, menuShown = false, isLoggedIn = false, onLoginFacebook = noop, onLoginGoogle = noop, onLogout = noop, onToggleMenu = noop }) =>
  isLoggedIn ? (
    <Fragment>
      <a onClick={() => onToggleMenu()}>
        <img className="User__photo" src={user.photoURL} alt={user.displayName} />
      </a>
      {menuShown && (
        <Menu>
          {/* <div className="Menu__title">{user.displayName}</div> */}
          <a className="Menu__item" onClick={onLogout}>
            Logout
          </a>
        </Menu>
      )}
    </Fragment>
  ) : (
    <Fragment>
      <div className="Header__item">Login Options</div>
      <a className="Header__icon" onClick={onLoginFacebook}>
        <Icon icon={['fab', 'facebook-square']} />
      </a>
      <a className="Header__icon" onClick={onLoginGoogle}>
        <Icon icon={['fab', 'google']} />
      </a>
    </Fragment>
  );

export default UserNav;



// WEBPACK FOOTER //
// ./src/components/UserNav/UserNav.js